/* eslint-disable */
/* Please refactor this file, I temporarily disabled lint on this file to remove the long warnings */
/* Warnings may cause errors or false positive bugs on javascript, lets avoid that */

import React, {Component} from 'react';
import axios from 'axios';
import appConfig from '../../../../config';
import BillingItems from './BillingItems';
import {DateField, SelectField, InputField, TextAreaField} from '../../../commons/Inputs';
import Modal from '../../../commons/Modal/Modal';

let $ = window.jQuery;
let moment = window.moment;

export default class BillingStatement extends Component {

	state = {
		dataList : [],
		isSaving : false,
		loadingText: 'Saving',
		isRemoving : false,
		proceduresList : [],
		billingItem : [],
		total : 0,
		amount_paid : 0,
		balance : 0,
		vat_value : 0,
		senior_discount_value : 0,
		discount_type : '',
		remaining_balance : 0,
		total_paid : 0,
		makePaymentStatus : false,
		payment_option : [
			{value: 'cash',label : 'Cash'},
			{value: 'cheque',label : 'Cheque'},
			{value: 'credit_card',label : 'Credit Card'},
			{value: 'debit_card',label : 'Debit Card'},
			{value: 'bank_transfer',label : 'Bank Transfer'}
		],

		branches : [],
		creditUsedAmount:0,
		creditAmount: 0,
		creditInputAmount: '' 

	}

	componentWillMount() {
		this.getBillingStatement();
	}

	getBillingStatement = () => {
		let url = appConfig.apiUrl + 'dental/billing/' + this.props.patient_id;
		
		axios.get(url).then((response) => {
            let data = response.data.data;
        	
            if(data.length > 0)
            {
            	this.setState({dataList : data});
            }
            
            
        }).catch((error) => { 
            console.log(error)
        });
	}

	getCredits = () => {
		let url = appConfig.apiUrl + 'dental/credit/' + this.props.patient_id;
		
		axios.get(url).then((response) => {
            let data = response.data.data;
        	
            if(Object.keys(data).length > 0)
            {
            	this.setState({
            		creditAmount : data.amount
            	})
            }
            
            
        }).catch((error) => { 
            console.log(error)
        });
	}

	componentDidMount() {
		$('#payment_amount').inputmask("numeric", {
            radixPoint: ".",
            groupSeparator: ",",
            digits: 2,
            autoGroup: true,
            // prefix: '₱ ',
            rightAlign: false,
            autoUnmask: true,
            oncomplete: (e) => {
            	console.log(e.target.value)
            },
            max: 999999.99 //max val on api DECIMAL(8, 2)
        });

        this.setState({branches : this.props.branches});
        this.getCredits();
	}

	componentWillReceiveProps(nextProps) {

        if (nextProps.billingUpdateId) {
            if(nextProps.billingUpdateId == this.props.billingUpdateId) {
                this.getBillingStatement();
            }
        }

		if(Object.keys(nextProps.data).length > 0)
		{
			let list = this.state.dataList;
			
			// if(typeof nextProps.data.is_voided === 'undefined' && !this.state.makePaymentStatus)
			if(typeof nextProps.data.is_voided === 'undefined')
			{
				let index = list.findIndex((item) => item.id == nextProps.data.id);
				// console.log(index)
				if(index == -1)
				{
					nextProps.data.is_voided = 0;
					list.unshift(nextProps.data); // setState to dataList
				}
				 
			}

			// this.setState({dataList : list},() => {
				// console.log(this.state.dataList)
			// });			
		}

	}

	handlerClickRow = (data) => {

		this.setState({
			loadingText : 'Saving',
			isSaving : false
		});
		
		let total = 0
		let vat = 0.12;
		let subTotal = 0;
		let seniorVat = 0.20;
		let discount_type = data.billing.discount_type;
		let discount = data.billing.discount;
		let senior_discount = data.billing.senior_discount;
		let vat_discount = data.billing.vat_discount;
		let total_paid = typeof data.billing.total_paid !== 'undefined' ? data.billing.total_paid : 0;
		let vat_value = 0;
		let senior_value = 0;
		let remaining_balance = 0;
		
		data.billing.treatment_records.forEach((item,i) => { // total price
			subTotal += item.price
		});

		total = subTotal;

		if(vat_discount > 0) // FORMULA = price / (1 + vat) VAT DISCOUNT
		{
			total = subTotal / (1 + vat);
			vat_value = total * vat;
		}

		if(senior_discount > 0) // senior discount
		{
			let total_withVat = subTotal / (1 + vat); // computed vat value

			total = total_withVat / (1 + seniorVat);

			senior_value = total * seniorVat;
		}

		if(discount > 0) // discount input
		{
			if(discount_type == 'price')
			{
				discount_type = '';
				total = total - discount;

			}else{
				discount_type = '%';
				total = total - (total * (discount / 100))
			}
		}

		remaining_balance = total - total_paid; // minus payments

		// if(total <= 0)
		// {
		// 	this.setState({
		// 		loadingText : 'Paid',
		// 		isSaving : false
		// 	});
		// }

		if(remaining_balance <= 0) // balance is zero 
		{
			//alert('Balance is already 0');
            App.blockUI({
                message: 'Balance is already zero. Click to continue.',
                zIndex: 99999,
                boxed: true
            })
            $('.blockOverlay').on('click', () => {
                App.unblockUI();
            });
			// return;
		}

		this.setState({
			billingItem : data.billing,
			proceduresList : data.billing.treatment_records,
			total : total,
			vat_value : vat_value,
			senior_discount_value : senior_value,
			discount_type : discount_type,
			total_paid : total_paid,
			remaining_balance : remaining_balance
		},() => {
			$('#makePaymentModal').modal('show');
		});
	}

	handlerSaveMakePayment = () => {
		let balance = this.state.remaining_balance;
		let paymentAmount = $('#payment_amount').val();
		// console.log(Math.round(balance * 100) / 100,paymentAmount);return;
		if(paymentAmount > Math.round(balance * 100) / 100)
		{
			App.blockUI({
                message: 'Remaining balance is '+ balance +'. Click to continue.',
                zIndex: 99999,
                boxed: true
            })
            $('.blockOverlay').on('click', () => {
                App.unblockUI();
            });
			return;
		}

		let date = $('#makePaymentModal input[name=date_payment]').val();
		let mode = $('#makePaymentModal select[name=mode_payment]').val();
		let amount = $('#makePaymentModal input[name=payment_amount]').val();
		let branch = $('#makePaymentModal select[name=branch_id]').val();
		let remarks = $('#makePaymentModal textarea[name=payment_remarks]').val();
		let billing = this.state.billingItem;
		let id = billing.id;

		if(balance < 0) // validation
		{
			return;
		}
		
		if(branch == 0) // validation
		{
			$('#makePaymentModal select[name=branch_id]').focus();
			return;
		}

		if(paymentAmount <= 0) // validation
		{
			if(this.state.creditUsedAmount <= 0)
			{
				$('#payment_amount').focus();
				return;
			}
		}

		let data = {
			billing_statement_id : id,
			price : (Number(amount) + Number(this.state.creditUsedAmount)),
			facility_id : branch,
			date : moment(date).format('YYYY-MM-DD'),
			mode : mode,
			remarks : remarks,
			credit_amount : this.state.creditUsedAmount
		}

		this.setState({isSaving : true});

		let url = appConfig.apiUrl + 'dental/payments/' + this.props.patient_id;

		axios.post(url, data).then((response) => {
            
            let data = response.data.data;
            
            let balance = 0;
            let total = this.state.total;
            let list = this.state.dataList;
            
            list.map((item , i) => {
            	if(item.id == data.billing_statement_id) // update payments
            	{
            		let arr = item.payments;
            		item.total_paid = data.total_paid; // update total_paid

	        		arr.push(data)
	        		return	
            	}
        		
            })
            
            this.setState({
            	dataList : list,
            	isSaving : false,
            	makePaymentStatus : true,
            	creditUsedAmount : 0
            },() => {
            	$('#makePaymentModal').modal('hide');
            	$('#payment_amount').val('');
            	
            });

            this.props.onChangeState();

        }).catch((error) => { 
            console.log(error)
        });	
	}

	handlerCloseModal = () => {
		$('#payment_amount').val('')
	}

	closeModal = () => {

	}

	handleOnDelete = (e) => {
		this.setState({isRemoving : true});
		let billing = this.state.billingItem;
		
		let url = appConfig.apiUrl + 'dental/billing/void/' + billing.id;
		let data = {};
		let dataList = this.state.dataList;

		axios.post(url, data).then((response) => {
			let res = response.data.data;
			
			dataList.forEach((item, i) => {
				if(item.id == res.id)
				{
					item.is_voided = 1;
				}
			});

			this.setState({
				isRemoving : false,
				dataList,
				makePaymentStatus : true
			},() => {

				this.props.onVoid(billing.treatment_records); 
				$('#makePaymentModal').modal('hide');
				$('#deleteBillingStatement').modal('hide');
			});


        }).catch((error) => { 
            console.log(error)
        });	
	}

	printBillingPDF = (e) => {
		let data = this.state.billingItem;
		
		let session = localStorage.getItem('token');
		
		let url = `${appConfig.apiUrl}dental/billing/pdf/${data.id}?access_token=${session}`;
       
        $('#billingStatementModalPDF').find('iframe').prop('src', url);
        $('#billingStatementModalPDF').modal('show');
	}

	addNewTreatment = (e) => {
		let bill = this.state.billingItem;
		this.props.onAddNewTreatment(bill);
	}

	handleUseCreditAmount = (e) => {
		let credit_amount = this.state.creditAmount;
		let credit_used_amount = this.state.creditUsedAmount;
		let credit_input_amount = this.state.creditInputAmount;
		let remainingBalance = this.state.remaining_balance;
		console.log(credit_amount, credit_input_amount);
		if(Number(credit_amount) < Number(credit_input_amount))
		{
			// alert('Not enough Credits')
			App.blockUI({
                message: 'Not enough Credits',
                zIndex: 99999,
                boxed: true
            })
            $('.blockOverlay').on('click', () => {
                App.unblockUI();
            });
			return;
		}
		if(Number(remainingBalance) < Number(credit_input_amount))
		{
			App.blockUI({
                message: 'Balance is only ' + remainingBalance,
                zIndex: 99999,
                boxed: true
            })
            $('.blockOverlay').on('click', () => {
                App.unblockUI();
            });
			return;
		}

		let creditAmount = Number(credit_amount) - Number(credit_input_amount);
		let creditUsedAmount = Number(credit_used_amount) + Number(credit_input_amount);
		let remainingBal = Number(remainingBalance) - Number(creditUsedAmount);

		this.setState({
			creditAmount,
			creditUsedAmount,
			remaining_balance : remainingBal
		});

		$('#useCreditForm').modal('hide');
	}

	handleAddCredits = (e) => {
		
		let form = $('#addCreditsForm');
		let data = form.serializeArray();
		let url = appConfig.apiUrl + 'dental/credit/' + this.props.patient_id;
		let amount_val = form[0].amount.value;
		let creditAmount = Number(this.state.creditAmount) + Number(amount_val)
		if(!creditAmount)
		{
			form[0].amount.focus();
			return;
		}

		this.setState({
			isRemoving: true
		});
		
		axios.post(url, $.param(data)).then((response) => {
			console.log(response)
			this.setState({
				isRemoving: false,
				creditAmount
			});
			$('#addMoreCredits').modal('hide');
        }).catch((error) => { 
            console.log(error)
        });
	}

	render () {
		let list = this.state.dataList;
		let proceduresItems = this.state.proceduresList;
		let bill = this.state.billingItem;
		let totalCharge = 0;
		let totalPaid = 0;
		let totalBalance = 0;

		return (
			<div className="table-scrollable">
				<table className="table table-hover table-striped">
					<thead>
						<tr>
							<th>Billing Date</th>
							<th>Branch</th>
							<th>Procedure</th>
							<th>Charge</th>
							<th>Quantity</th>
							<th>Amount Paid</th>
							<th>Balance</th>
						</tr>
					</thead>
					<tbody>
						{list.map((item, i) => {

							let procedure_count = item.treatment_records.length;
							let price = 0;
							let balance = 0;
							let realBalance = 0;
							let subTotal = 0;
							let total = 0;
							let vat = 0.12;
							let seniorVat = 0.20;

							let amount_paid = 	item.payments.map((payment, j) => { // computed amount paid
													return price += payment.price
												});

												item.treatment_records.map((balance, b) => {
													return subTotal += balance.price
												});

							total = subTotal;

							if(item.vat_discount > 0) // FORMULA = price / (1 + vat) VAT DISCOUNT
							{
								total = subTotal / (1 + vat);
							}

							if(item.senior_discount > 0) // senior discount
							{
								let total_withVat = subTotal / (1 + vat); // computed vat value

								total = total_withVat / (1 + seniorVat);
							}

							if(item.discount > 0) // discount input
							{
								if(item.discount_type == 'price')
								{
									total = total - item.discount;

								}else{
									total = total - (total * (item.discount / 100))
								}

							}

							balance = total - price;
							if(item.is_voided == 0)
							{
								totalPaid += price; // Total payment
								totalBalance += balance; // Total balance
								totalCharge += subTotal;
							}

							if(balance < 0)
							{
								realBalance = balance;
								balance = 0;
							}

							return	item.treatment_records.map((treatment, j) => {

										let data = {
											indexKey : j,
											count : procedure_count,
											dateKey : moment(item.date).format('MMMM DD, YYYY'),
											treatments : treatment,
											billing: item
										};

										// if(item.is_voided == 0)
										// {
										// 	totalCharge += data.treatments.price;
										// }
										
										return <BillingItems items={data} key={j} onclick={this.handlerClickRow} amount={price} balance={balance} realBalance={realBalance} onPrint={this.printBillingPDF} />

									})
						})}

						{
							list.length == 0 ?
							<tr style={{borderBottom : '1px solid #ddd'}}>
								<td colSpan="7" className="text-center">No Billing Statement Available</td>
							</tr>
							
							:

							null
						}

						<tr>
							<td colSpan="3" className="text-right"><strong>TOTAL:</strong></td>
							<td colSpan="2" style={{borderTop : '1px solid #000'}}>{parseFloat(Math.round(totalCharge * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
							<td style={{borderTop : '1px solid #000'}}>{parseFloat(Math.round(totalPaid * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
							<td style={{borderTop : '1px solid #000'}}>{parseFloat(Math.round(totalBalance * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
						</tr>
					</tbody>
				</table>
				<Modal
                    id="makePaymentModal"
                    header="Billing Statement"
                    onNegativeClickEvent={this.handlerCloseModal}
                    onPositiveClickEvent={this.handlerSaveMakePayment}
                    isSaving={this.state.isSaving}
                    loadingText={this.state.loadingText}
                    onOptionalButtonClickEvent={this.printBillingPDF}
                    onOptionalButton2ClickEvent={this.addNewTreatment}
                    optionalButton="Print"
                    optionalButton2="Add treatment"
                    positiveButton="Save"
                    width="1080">

                    <div className="row">
                    	<div className="col-md-12">
                    		<form id="makePaymentsForm">
                    			<div className="row">
                    				<div className="col-md-6">
	                    				<div className="row">
		                    				<div className="container-fluid">
		                    					<table className="table table-hover table-light">
		                    						
		                    							{proceduresItems.map((item, i) => {
		                    								return	<tbody key={i}>
		                    											<tr>
			                    											<td><strong>{item.procedures.map((pro, k) => {
			                    													return pro.procedure + ', '
			                    											})}</strong></td>
			                    											<td className="text-right"><strong>{parseFloat(item.price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</strong></td>
			                    										</tr>
			                    										<tr>	
			                    											<td>Quantity</td>
			                    											<td className="text-right">x {item.quantity}</td>
			                    										</tr>
			                    									</tbody>
		                    							})}
		                    					</table>
		                    				</div>
		                    				<hr/>
		                    				<div className="container-fluid">
		                    					<div className="col-md-10 col-md-offset-1">
		                    						<table className="table table-hover table-light">
		                    							<tbody>
		                    								<tr>
			                    								{bill.vat_discount == 1 ? <td>Vat Exclusive</td> : null}
			                    								{bill.vat_discount == 1 ? <td className="text-right">{parseFloat(Math.round(this.state.vat_value * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td> : null}
			                    							</tr>
			                    							<tr>
			                    								{bill.senior_discount == 1 ? <td>Senior Citizen Discount</td> : null}
			                    								{bill.senior_discount == 1 ? <td className="text-right">{parseFloat(Math.round(this.state.senior_discount_value * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td> : null}
			                    							</tr>
			                    							<tr>
			                    								{bill.discount > 0 ? <td>Discount</td> : null}	
			                    								{bill.discount > 0 ? <td className="text-right">{this.state.discount_type + parseFloat(Math.round(bill.discount * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td> : null}	
			                    							</tr>
			                    							<tr>
			                    								<td><strong>TOTAL</strong></td>
			                    								<td className="text-right"><strong>{parseFloat(Math.round(this.state.total * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</strong></td>
			                    							</tr>
			                    							<tr>
			                    								<td>Amount Paid</td>
			                    								<td className="text-right">{parseFloat(Math.round((this.state.total_paid + this.state.creditUsedAmount) * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
			                    							</tr>
			                    							<tr>
			                    								<td><strong>Remaining Balance</strong></td>
			                    								<td className="text-right"><strong>{parseFloat(Math.round(this.state.remaining_balance * 100) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</strong></td>
			                    							</tr>
		                    							</tbody>
		                    						</table>
		                    					</div>
		                    				</div>
		                    				<div className="container-fluid">
		                    					<div className="col-md-10 col-md-offset-1">
			                    					<a className="red" data-toggle="modal" data-target="#deleteBillingStatement" style={{color: 'red'}}>
						                                <strong>Void Billing Statement</strong>
						                            </a>
					                            </div>
		                    				</div>
		                    				<div className="container-fluid">
		                    					<div className="col-md-10 col-md-offset-1">
			                    					<a className="blue" data-toggle="modal" data-target="#addMoreCredits">
						                                <strong>Add Credits</strong>
						                            </a>
					                            </div>
		                    				</div>
	                    				</div>
                    				</div>
                    				<div className="col-md-6">
                    					<h4><strong>Create a Payment</strong></h4>
                    					<div className="row">
                    						<div className="col-md-12">
	                    						<DateField val={moment().format('MMMM DD, YYYY')} id="date_payment" label="Date" help="input date" onChange={(e) => {}} />
	                    					</div>
                    					</div>
                    					<div className="row">
                    						<div className="col-md-12">
	                    						<SelectField val="" id="mode_payment" label="Mode of Payments" help="Select Chart" options={this.state.payment_option} onChange={() => {}}/>
	                    					</div>
                    					</div>
                    					<div className="row">
                    						<div className="col-md-12">
	                    						<SelectField val="" id="branch_id" label="Branch" help="Select Chart" options={this.state.branches} onChange={(e) => {}} multiple={false} />
	                    					</div>
                    					</div>
                    					<div className="row">
                    						<div className="col-md-12">
                    							Credit Amount <span className="badge badge-info"> {this.state.creditAmount} </span>
                    							<div className="btn-group btn-group-xs btn-group-solid">
                                                    <button type="button" className="btn red btn-xs" data-toggle="modal" data-target="#useCreditForm">Use</button>
                                                </div>
                                                {/*this.state.remaining_balance*/}
                    						</div>
                    					</div>
                    					<div className="row">
                    						<div className="col-md-12">
	                    						<InputField val="" id="payment_amount" label="Amount" help="Amount" type="text" />
	                    					</div>
                    					</div>
                    					<div className="row">
                    						<div className="col-md-12">
	                    						<TextAreaField val="" id="payment_remarks" label="Remarks" help="Remarks" onChange={(e) => {}} />
	                    					</div>
                    					</div>
                    				</div>
                    			</div>
                    		</form>
                    	</div>
                    </div>

                </Modal>

                <Modal
                    id="deleteBillingStatement"
                    header="VOID BILLING STATEMENT"
                    onNegativeClickEvent={this.closeModal}
                    onPositiveClickEvent={this.handleOnDelete}
                    positiveButton="Void"
                    isSaving={this.state.isRemoving}
                    width="640">

                    <div className="container-fluid">
                        <p>Are you sure you want to void this Billing Statement?</p>
                        <small>If this Billing Statement has previous payments, these payments will be considered Voided as well. <b>This action cannot be undone.</b></small>
                    </div>
                </Modal>

                <Modal
                	id="addMoreCredits"
                    header="ADD CREDITS"
                    onNegativeClickEvent={() => {}}
                    onPositiveClickEvent={this.handleAddCredits}
                    positiveButton="Save"
                    isSaving={this.state.isRemoving}
                    width="640">
                	
                    <div className="row">
                    	<div className="col-md-12">
                    		<form id="addCreditsForm">
                    			<div className="col-md-12">
                    				<InputField val="" id="amount" label="Amount" help="Amount" type="number" onChange={(e) => {}} />
                    			</div>
                    			{/*<div className="col-md-12">
                    				<TextAreaField val="" id="description" label="Description" help="Description" onChange={(e) => {}} />
                    			</div>*/}
                    		</form>
                    	</div>
                    </div>

                </Modal>
                <Modal
                	id="useCreditForm"
                    header="CREDITS"
                    onNegativeClickEvent={() => {}}
                    onPositiveClickEvent={this.handleUseCreditAmount}
                    positiveButton="Use"
                    isSaving={this.state.isRemoving}
                    width="640">
                	
                	<div className="row">
                    	<div className="col-md-12">
                    		{/*<form id="useCreditsForm">*/}
                    			<div className="col-md-12">
                    				<InputField val={this.state.creditInputAmount} id="creditAmountUse" label="Amount" help="Amount" type="number" onChange={(e) => { this.setState({creditInputAmount: e.target.value}) }} />
                    			</div>
                    		{/*</form>*/}
                    	</div>
                    </div>

                </Modal>

                <div id="billingStatementModalPDF" data-width="900" className="modal fade in"
                     tabIndex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">

                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true" />
                            <h4 className="modal-title">Billing Statement</h4>
                        </div>
                        <div className="modal-body">
                            <iframe style={{ width: '100%', height: '500px'}}></iframe>
                        </div>
                    </div>
                </div>
			</div>
		)
	}

}



/** WEBPACK FOOTER **
 ** ./src/components/patient/Treatment_record/BillingStatement.js
 **/